import styled from 'styled-components'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  width: 100%;
  height: 15px;
  display: flex;
  flex-direction: ${(props) => props.direction};
  align-items: center;
  gap: ${(props) => props.direction === 'row' ? '6px' : '2px'};
`

export const LoadingContainer = styled.div`
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height + 2}px`};
  border: 1px solid #CCCCCC;
  border-radius: 99px;
`

export const LoadedIndicator = styled.div`
  width: ${({ totalValue, currentValue }) => `${(currentValue / totalValue) * 100}%`};
  height: ${({ height }) => height + 'px'};
  background-color: ${({ color, totalValue, currentValue }) => {
    const percentage = (currentValue / totalValue) * 100

    return color || (
      percentage >= 67 ? '#44CF6C' : (percentage < 34 ? '#FF3939' : '#FFC100')
    )
  }};
  border-radius: 15px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 1px;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 1px;
  padding: 0px;
`
